import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotifierService {

  config: any;

  constructor(private toastr: ToastrService) {
    this.config = { closeButton: true, timeOut: 4000, progressBar: true, enableHtml: true };
  }

  public showSuccess(message: string) {
    this.toastr.success(message, 'Successful!', this.config);
  }

  public showError(message: string) {
    this.toastr.error(message, "Something went wrong!", this.config);
  }
}
